import { FC } from 'react';
import { useStore } from '@nanostores/react';
import { $animationMode, TransitionMode } from '../../store/app';
import styled from 'styled-components';
import { darkBlueBackground, yellow } from '../colors';

const TabGroup = styled.div`
  display: flex;
  gap: 8px;
`;

const TabButton = styled.button<{
  active: boolean;
}>`
  padding: 8px 20px;
  border-radius: 14px;
  border: none;
  background: ${({ active }) => (active ? yellow : darkBlueBackground)};
  color: ${({ active }) => (active ? '#000' : '#fff')};
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
  outline: none;
`;

export const SwitchTransitionModeButton: FC = () => {
  const animationMode = useStore($animationMode);

  return (
    <TabGroup>
      <div style={{ color: '#fff', textAlign: 'right', alignSelf: 'center', fontSize: '10px' }}>
        Playback
        <br />
        based on:
      </div>
      <TabButton
        active={animationMode === TransitionMode.TIME_BASED}
        onClick={() => $animationMode.set(TransitionMode.TIME_BASED)}
      >
        Time
      </TabButton>
      <TabButton
        active={animationMode === TransitionMode.DISTANCE_BASED}
        onClick={() => {
          $animationMode.set(TransitionMode.DISTANCE_BASED)
        }}
      >
        Realistic
      </TabButton>
    </TabGroup>
  );
};